import { useDispatch, useSelector } from 'react-redux';

import {
  createDraftApplicationThunk,
  uploadResumeThunk,
  getResumePrefillStatusThunk,
  uploadVideoThunk,
  updateCandidateProfileThunk,
  submitApplicationThunk,
} from '@/modules/candidate/store/applicationThunk';

import type {
  UpdateCandidateProfilePayload,
} from '@/modules/candidate/api/application.api';

import { clearApplication } from '@/modules/candidate/store/applicationSlice';


export const useApplication = () => {
  const dispatch: any = useDispatch();

  const applicationState = useSelector(
    (state: any) => state.application
  );


  const createDraft = (
    jobId: string,
    source = 'CAREER_PAGE',
    referralToken?: string,
    referralUtm?: {
      utm_source?: string;
      utm_medium?: string;
      utm_campaign?: string;
      utm_content?: string;
      utm_term?: string;
    }
  ) => {
    return dispatch(
      createDraftApplicationThunk({
        jobId,
        source,
        referralToken,
        referralUtm,
      })
    );
  };


  const uploadResume = (
    draftId: string,
    file: File
  ) => {
    return dispatch(
      uploadResumeThunk({
        draftId,
        file,
      })
    );
  };


  const getResumePrefillStatus = (
    draftId: string
  ) => {
    return dispatch(
      getResumePrefillStatusThunk({
        draftId,
      })
    );
  };


  const updateCandidateProfileAPI = (
    payload: UpdateCandidateProfilePayload
  ) => {
    return dispatch(
      updateCandidateProfileThunk(
        payload
      )
    );
  };


  const uploadVideo = (
    draftId: string,
    file: File
  ) => {
    return dispatch(
      uploadVideoThunk({
        draftId,
        file,
      })
    );
  };


  const submitDraft = (
    draftId: string
  ) => {
    return dispatch(
      submitApplicationThunk({
        draftId,
      })
    );
  };


  const resetApplication = () => {
    dispatch(
      clearApplication()
    );
  };


  return {
    ...applicationState,

    createDraft,

    uploadResume,

    getResumePrefillStatus,

    uploadVideo,

    submitDraft,

    updateCandidateProfileAPI,

    resetApplication,
  };
};


export default useApplication;